import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=36a0678a&"
import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=36a0678a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports